import Alpine from "../shared/utils/alpine"
import collapse from "@alpinejs/collapse"
import { FrontendStore } from "../stores/frontend"
import { BadgeNumber, CouponCopy, EditorRenderer, Expander, ImageModal, SearchModal } from "./ui"
import { PhoneValidator, ProfileForm } from "./users"
import { CartItem, CartBrand, CartSummary, CouponManager } from "./carts"

import { InvoiceForm, CarrierValidator, VatValidator } from "./invoices"
import { AddressForm } from "./addresses"
import { ProductPhotoPicker, ProductVariant } from "./products"
import { ShippingSelector } from "../components/shipping/shipping_selector"
import { paymentMethodSelector } from "../components/ui/payment_method_selector"
import { Flash } from "../shared/ui"
import { CopyText, ShareButton } from "../shared/utils"
import { TappayForm, UnipockPayment } from "./payments"
import { RealtimeChatModal, UnreadMessageBadge, ReturnExchangeChat } from "./chat"
import { notificationPanel } from "./ui/notification_panel"
import { returnExchangeForm } from "./forms/return_exchange_form"
import { OrderFormValidator } from "./orders/form_validator"
import { OrderSummary } from "./orders/order_summary"
import { ProfileAutofill } from "./orders/profile_autofill"
import { WebViewOAuthHandler } from "./auth/webview_oauth_handler"
import "./carousel/embla"

// Plugins
Alpine.plugin(collapse)


Alpine.components(
  AddressForm,
  BadgeNumber,
  CarrierValidator,
  CartItem,
  CartBrand,
  CartSummary,
  CouponManager,
  CopyText,
  ShareButton,
  EditorRenderer,
  Expander,
  Flash,
  ImageModal,
  InvoiceForm,
  paymentMethodSelector,
  PhoneValidator,
  ProductPhotoPicker,
  ProductVariant,
  ProfileForm,
  SearchModal,
  VatValidator,
  TappayForm,
  WebViewOAuthHandler,
)

Alpine.data('RealtimeChatModal', RealtimeChatModal)
Alpine.data('UnreadMessageBadge', UnreadMessageBadge)
Alpine.data('ReturnExchangeChat', ReturnExchangeChat)

Alpine.data('CouponCopy', CouponCopy)
Alpine.data('notificationPanel', notificationPanel)
Alpine.data('return_exchange_form', returnExchangeForm)
Alpine.data('shippingSelector', ShippingSelector)
Alpine.data('paymentMethodSelector', paymentMethodSelector)
Alpine.data('orderFormValidator', OrderFormValidator)
Alpine.data('orderSummary', OrderSummary)
Alpine.data('profileAutofill', ProfileAutofill)
Alpine.data('shareButton', ShareButton)
Alpine.data('invoiceForm', InvoiceForm)
Alpine.data('profileForm', ProfileForm)
Alpine.data('unipockPayment', UnipockPayment)


// Store
Alpine.store("frontend", FrontendStore)

window.Alpine = Alpine
import "alpine-turbo-drive-adapter"

Alpine.start()
